import * as React from 'react';
import { SVG } from '../../Utils/SVG';
import './style.css';

export interface SocialLinkProps {
  className?: string;
  icon: string;
  text: string;
  url: string;
  target?: string;
}

export interface SocialLinkState {
  /* empty */
}

export class SocialLink extends React.Component<
  SocialLinkProps,
  SocialLinkState
> {
  render() {
    const { className, icon, target, text, url } = this.props;

    const socialLinkClasses = 'edge-of-play-link social-link';

    const classNames = className
      ? `${socialLinkClasses} ${className}`
      : socialLinkClasses;

    return (
      <a className={classNames} href={url} target={target}>
        <SVG className="social-link-icon" src={icon} />
        {text}
      </a>
    );
  }
}

export default SocialLink;



// WEBPACK FOOTER //
// ./src/app/components/Common/SocialLink/index.tsx